import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ACTION_ISSUE_TYPES } from '../common/endpoints';
import { ActionIssueType } from '../model';
import { HttpService } from './http.service';


@Injectable()
export class ActionIssueTypeService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService
    ) { }

    getAllIssueTypes(): Promise<ActionIssueType[]> {
        return firstValueFrom(this.http.get<ActionIssueType[]>(ACTION_ISSUE_TYPES));
    }

}